import styled from 'styled-components/macro'

export const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: .5rem;
`